// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FbRb","name":"styles_name__3rvW4","phone":"styles_phone___NObz"};